export const PipelineTypesEnum = {
  Unconstraint: 'Unconstraint',
  Predetermined: 'Predetermined',
  Continue: 'Continue',
  Double: 'Double',
} as const;

export const selectionType = {
  spread: 'Spread',
  subSpread: 'SubSpread',
} as const;

export const sequenceGenerationStatus = {
  Pending: 'Pending',
  Started: 'Started',
  InProgress: 'InProgress',
  Completed: 'Completed',
  ErrorOccurred: 'ErrorOccurred',
} as const;

export const importDataSpread = {
  selectSpread: 'Select a Sequence',
  createSpread: 'Create New Sequence',
  anySpread: 'Any',
  selectSpreadPlaceholder: null,
} as const;

export const importDataSubSpread = {
  selectSubSpread: 'Select a Sub-sequence',
  createSubSpread: 'Create New Sub-sequence',
  anySubSpread: 'Any',
  selectSubSpreadPlaceholder: null,
} as const;

export const sequenceStatusErrorMessages = {
  invalidInputParametersError:
    'Input Parameters are invalid for the algorithm; Pass correct Project no, Sequence/Sub-sequence ID\'s',
  zeroPipesAvailableError:
    'Available number of pipes are zero for the Sequence/Sub-sequence. Check pipe details tab',
  meanMaxPendingError: 'Mean max calculations are pending for the project!',
  fitMatrixExceptionError: 'Exception raised while building a fit matrix',
  invalidConfigurationError:
    'Invalid Configuration(s), Check the project configuration',
  invalidResponseFromDbError:
    'Failed to receive a valid response from the database. Check the AWS Cloud Watch for the detailed error.',
} as const;

export const configurationConstants = {
  PipelineTypesEnum,
  selectionType,
  sequenceGenerationStatus,
  importDataSpread,
  importDataSubSpread,
  sequenceStatusErrorMessages,
};
